"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Counter = require("./Counter");
Object.keys(_Counter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Counter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Counter[key];
    }
  });
});
